import React from 'react';
import { SparklesIcon, SproutIcon, LightbulbIcon } from 'lucide-react';
export const Process = () => {
  const steps = [{
    icon: SparklesIcon,
    title: 'На первой сессии',
    description: 'Мы формулируем ваш запрос, уточняем цели и обсуждаем желаемый результат. После встречи я могу отправить несколько тестов, чтобы оценить состояние и увидеть точку, с которой мы начинаем.'
  }, {
    icon: SproutIcon,
    title: 'Во время сессии',
    description: 'Я задаю вопросы, моделирую ситуации, предлагаю упражнения и даю обратную связь. Мы можем разбирать эпизоды, смотреть на реакции и искать новые способы взаимодействия — всё, что помогает двигаться к решению вашего запроса.'
  }, {
    icon: LightbulbIcon,
    title: 'После сессии',
    description: 'Обычно я даю необязательное домашнее задание — небольшой шаг, который помогает перенести изменения в повседневную жизнь.'
  }];
  return <section className="w-full pt-2 pb-10 px-6 md:px-10 bg-white relative overflow-hidden" data-id="element-211">
      <div className="max-w-7xl mx-auto" data-id="element-212">
        <div className="text-center mb-16 space-y-2" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-214">
            Как проходят наши встречи
          </h2>
        </div>
        <div className="grid lg:grid-cols-2 gap-10 items-center" data-id="element-215">
          {/* Left - Image */}
          <div className="order-2 lg:order-1 flex justify-center" data-id="element-216">
            <div className="relative w-full max-w-sm" data-id="element-217">
              <div className="absolute inset-0 bg-gradient-to-br from-[#4a9d63] to-[#3d8f5a] rounded-[32px] transform -rotate-2" data-id="element-218"></div>
              <div className="relative rounded-[32px] overflow-hidden transform rotate-1 shadow-2xl" data-id="element-219">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hiQkVaWeSsGxGVDN2WPmKK/7D423439-C8B8-46A6-A32C-89323FC0212B.jpg" alt="Мария Бродская в кабинете" className="w-full aspect-[3/4] object-cover" data-id="element-220" />
              </div>
            </div>
          </div>
          {/* Right - Steps */}
          <div className="order-1 lg:order-2 space-y-5" data-id="element-221">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-5 hover:shadow-md transition-all" data-id="element-222">
                  <div className="flex gap-4" data-id="element-223">
                    <div className="flex-shrink-0" data-id="element-224">
                      <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#3d8f5a] to-[#2c5f2d] flex items-center justify-center shadow-lg" data-id="element-225">
                        <Icon className="w-6 h-6 text-white" data-id="element-226" />
                      </div>
                    </div>
                    <div className="flex-1 space-y-1.5" data-id="element-227">
                      <div className="flex items-center gap-2.5" data-id="element-228">
                        <span className="text-xl font-bold text-[#3d8f5a]" data-id="element-229">
                          {index + 1}
                        </span>
                        <h3 className="text-lg font-bold text-gray-900" data-id="element-230">
                          {step.title}
                        </h3>
                      </div>
                      <p className="text-sm text-gray-700 leading-relaxed" data-id="element-231">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
      {/* Decorative element */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#4a9d63] rounded-full opacity-5 blur-3xl pointer-events-none" data-id="element-232"></div>
    </section>;
};